import { dedupedPost } from 'src/app/core/utils/api-dedupe.util';
import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  RouterStateSnapshot,
} from "@angular/router";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { WalletInfo } from "src/app/core/models/wallet-info.model";
import { Subscription } from "rxjs";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { API as AWS_API } from "aws-amplify";
import { UserService } from "src/app/core/services/user.service";
import * as $ from "jquery";
import { Location } from "@angular/common";
import { LandingPageService } from "src/app/core/services/landing-page.service";
import { AppService } from "src/app/core/services/app.service";
import { StorageService } from "src/app/core/services/storage.service";
import { CONST_AWS_API, API } from "src/app/core/constants";
import { ConsumerSignInComponent } from "../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WalletConnectDialogComponent } from "../../wallet-connect-dialog/wallet-connect-dialog.component";
import { Title } from "@angular/platform-browser";
import { PubNubService } from "src/app/core/services/pubnub.service";
import { UtilityService } from "src/app/core/services/utility.service";
import { Web3Service } from 'src/app/core/services/web3.service';
import { MERCH_API } from "src/app/core/constants";
import { AppPaymentTVService } from "src/app/core/services/app-payment-tv.service";
import { AffiliateService } from "src/app/core/services/affiliate.service";
import { MerchCartService } from "src/app/core/services/merch-cart.service";
import { TopMenuEventsService } from "src/app/core/services/top-menu-events.service";
import { buildTopMenuVars } from "../ic-top-menu/top-menu-theme";
import { ICONS as UD_MENU_ICONS } from "../../user-dashboard-v2/ud-sidebar/menu-icons";
import { TopMenuEvent } from "../ic-top-menu/top-menu-events.model";
import { addRecentSearch, readRecentSearches } from "../ic-top-menu/recent-searches";
import { isEventDetailUrl, topMenuEventPath } from "../ic-top-menu/top-menu-event-link";
import { SearchSuggestionsService } from "../ic-top-menu/search-suggestions.service";
import { SearchSuggestion, SearchSuggestionGroup } from "../ic-top-menu/search-suggestions.model";
import { opensSameDetailPage } from "../ic-top-menu/search-suggestion-link";
import { ensureContrast } from "src/app/core/utils/color.util";

// New-design right menu icons: the dashboard sidebar set plus this menu's group names and types.
const SIDE_MENU_ICONS: Record<string, string> = {
  ...UD_MENU_ICONS,
  "My Profile": "fa-user-circle-o",
  "My Events": "fa-calendar-check-o",
  "My Payments": "fa-credit-card",
  upcomming_events: "fa-calendar",
  "tips-donations": "fa-heart-o",
};

@Component({
  selector: "app-ic-header",
  templateUrl: "./ic-header.component.html",
  styleUrls: ["./ic-header.component.scss"],
  host: {
    "(document:click)": "onClick($event)",
  },
})
export class IcHeaderComponent implements OnInit {
  isCryptoWallet = environment.clientDetails.required_crypto_wallet;
  enableCommunity = environment.enable_community;
  /** New-design top menu (ENABLE_NEW_TOP_MENU); the old header markup is kept for false. */
  newTopMenu = (environment as any).enableNewTopMenu === true;
  menuScrolled = false;
  topMenuEvents: TopMenuEvent[] = [];
  recentSearches: string[] = [];
  topMenuSuggestions: SearchSuggestionGroup[] = [];
  topMenuSuggestionsLoading = false;
  topMenuSuggestionsFailed = false;
  private suggestionsSubscr: Subscription;
  private topMenuEventsKey = '';
  private topMenuEventsPending = false;
  private topMenuEventsSubscr: Subscription;
  @ViewChild("sidenav", { static: false })
  sidenav: MatSidenav;
  @ViewChild("rightsidenav", { static: false })
  rightsidenav: MatSidenav;
  menuNames: any = [];
  menuList: any;
  isLiveEvent: boolean = false;
  pId: any = "";
  pName: any = "";
  vName: any = "";
  id: any = "";
  orgInfo: any;
  routerevents: any;
  userList: any;
  subscriptionRightTabMenuActive: Subscription;
  userInfoSubscription: Subscription;
  userInfo: any = {};
  displayName = "";
  profileName = "";
  channelUrl: string;
  liveEventSubscr: Subscription;
  orgInfoSubscr: Subscription;
  snapshot: RouterStateSnapshot;
  publisherStreamSubscription: Subscription;
  isLiveStream: any;
  hideSignIn: boolean = false;
  subscriptionRightTabUserActive: Subscription;
  openChat: boolean;
  loggedIn: boolean = false;
  expoInfoSubscr: Subscription;
  expoInfo: any;
  ticket_key: any;
  userIdParam: any;
  event_id: any;
  user_id: any;
  isPubNubChannelAvailable: boolean;
  openPubNubChannel: any;
  isNetworkNotification: boolean = false;
  message: any;
  inviteKey: string;
  ticketStatus: Subscription;
  searchCurrency: any = "";
  currencyJSON: any = [];
  getCurrency: any;
  currenciesList: any = [];
  currency: any;
  currentLocation: any;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  performerInfoSubscr: Subscription;
  routeParamsSubscr: Subscription;
  deviceData: Subscription;
  channelName: any;
  searchKeyWords: any;
  appType: any = "";
  deviceType: string;
  walletInfo: WalletInfo;
  walletID: string;
  available_balance: any;
  crypto_balance: Number;
  cryptoAmount: any;
  cryptoSymbol: string;
  showHeader: boolean = true;
  show247Channel: boolean = false;
  featureList: any = [];
  communityAccess: boolean = false;
  organizationKey: string;
  organizationId: any;
  isAffiliate: boolean = false;
  isGroupAffiliate: boolean = false;
  affiliateKey: string;
  affiliateOrgResults: any[] = [];
  fanPrograms: any[] = [];
  getCartProdCountSubscription: Subscription;
  @ViewChild('scrollElement', { static: false }) scrollElement: ElementRef;
  marketplacetext:string = '';
  cartProdCount: any = 0;
  cartId: any;
  showCartIcon: boolean = false;
  copyLinkPopup: boolean = false;
  cartProducts: any;
  leftMenu: boolean = false;
  screenStatusSubscription:Subscription;
  disableAccess: boolean = false;
  groupsData: any;
  originalChannelLogo: any;
  isGroupRoute: boolean = false;

  constructor(
    private eleRef: ElementRef,
    private location: Location,
    public router: Router,
    private landingPageService: LandingPageService,
    private appService: AppService,
    private userService: UserService,
    private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private pubnubService: PubNubService,
    private ngxLoader: NgxUiLoaderService,
    private dialog: MatDialog,
    private titleService: Title,
    private utilityService: UtilityService,
    private web3service: Web3Service,
    private commonSubscribeService: CommanSubscribeService,
    private appPaymentService: AppPaymentTVService,
    private cdRef:ChangeDetectorRef,
    private affiliateService: AffiliateService,
    private merchCartService: MerchCartService,
    private topMenuEventsService: TopMenuEventsService,
    private searchSuggestionsService: SearchSuggestionsService
  ) {
    this.subscriptionRightTabMenuActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 1000);
        }
      });
    this.commanSubscribeService.walletInfoSubject.subscribe((result) => {
      if (result?.organizationId === this.commanSubscribeService.orgId) {
        this.walletInfo = result.wallet;
      }
    });
    this.routerevents = router.events.subscribe((val) => {
      this.snapshot = router.routerState.snapshot;
      if (val instanceof NavigationEnd) {
        if (
          this.route &&
          this.route.firstChild &&
          this.route.firstChild.paramMap
        ) {
          // Re-subscribed on every NavigationEnd; drop the previous one so handlers don't stack up.
          if (this.routeParamsSubscr) this.routeParamsSubscr.unsubscribe();
          this.routeParamsSubscr = this.route.firstChild.paramMap.subscribe((params: any): void => {
            this.channelUrl = this.route.snapshot.pathFromRoot
              .map((o) => o.url[0])
              .join("");
            this.pId = params.params["pId"];
            this.pName = params.params["pName"];
            this.vName = params.params["vName"];
            this.id = params.params["id"];
            this.ticket_key = params.params["ticket_key"];
            this.userInfo = this.commanSubscribeService.userInfo;
            let eventId;
            if (
              !this.storageService.getItem("ticket_key") &&
              this.ticket_key != undefined
            ) {
              this.storageService.setItem("ticket_key", this.ticket_key);
              let id = this.ticket_key;
              if (id && id.includes("-")) eventId = id.split("-");
            }
            if (eventId)
              this.event_id = eventId ? eventId[0] : params.params["id"];
            // this.connectChannel()
            // this.getLiveEvent();
            // this.getOrgInfo();
          });

          this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
          let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
          if (perfomerInfoData && Object.keys(perfomerInfoData).length != 0) {
            this.getPerformerInfo(perfomerInfoData);
          }
          if (this.performerInfoSubscr) this.performerInfoSubscr.unsubscribe();
          this.performerInfoSubscr = this.commanSubscribeService
            .getPerfomerInfo()
            .subscribe((response) => {
              this.getPerformerInfo(response);
            });
          if (this.router.url.includes("channelSearch"))
            this.searchKeyWords = this.route.snapshot.queryParams.key;
          else this.searchKeyWords = "";
        }
      }
    });
    // console.log("this.route",route.snapshot.children[0].data.heading);
    if (
      this.route.snapshot.queryParams.vf == "mobile" ||
      (route.snapshot.children[0] &&
        route.snapshot.children[0].data &&
        route.snapshot.children[0].data.heading == "creator-pre_register")
    ) {
      this.hideSignIn = true;
    }
    // this.ticketStatus = this.userService.getTicketStatus().subscribe(response => {
    //   if (response) {
    // this.connectChannel();
    //   }
    // });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !event.url.includes('/community');
        const navSegments = event.url.split('/');
        const navGroupSlug = navSegments.length > 2 ? navSegments[2]?.split('?')[0] : null;
        const navMatchedGroup = this.groupsData?.find((g: any) => g.group_slug === navGroupSlug);
        if (navMatchedGroup) {
          this.org_info = { ...this.org_info, channel_logo: navMatchedGroup.group_logo || this.originalChannelLogo };
        } else if (this.originalChannelLogo) {
          this.org_info = { ...this.org_info, channel_logo: this.originalChannelLogo };
        }
        this.updateIsGroupRoute();
        this.evaluateAffiliateFlags();
      }
    });
  }
  onClick(event) {
    // New-design menu: a group header only opens its sub-menu, so the panel stays open.
    if (this.newTopMenu && event.target.closest?.(".tm-side .mat-expansion-panel-header")) {
      return;
    }
    if (event.target.id == "") {
      this.rightsidenav?.close();
    }
  }
  connectChannel() {
    if (this.storageService.getItem("ticket_key")) {
      this.ticket_key = this.storageService.getItem("ticket_key");
      this.event_id = this.ticket_key.split("-")[0];
    }
    if (this.ticket_key) {
      this.event_id = this.ticket_key ? this.ticket_key.split("-")[0] : 0;
      this.user_id = this.ticket_key ? this.ticket_key.split("-")[1] : 0;
    }
    this.pubnubService.init();
    if (this.user_id && this.event_id) this.connectPubNubChannels();
  }
  isShownSettings: boolean = false;
  settings() {
    if (!this.router.url.includes("/preview"))
      this.isShownSettings = !this.isShownSettings;
  }

  async ngOnInit() {
    let pageFrom = this.route.snapshot.queryParams['pageFrom'];
    this.disableAccess = this.router.url.includes('/preview') || pageFrom == 'eventForm' || pageFrom == 'communityForm';
    this.screenStatusSubscription = this.commanSubscribeService.getScreenStatus().subscribe(response => {
      this.leftMenu = response;
      this.cdRef.detectChanges();
    });
    this.cryptoSymbol = environment.clientDetails.crypto_symbol;
    let search = this.commanSubscribeService.searchVal;
    search = this.commanSubscribeService
      .getSearchKey()
      .subscribe((response) => {
        this.searchKeyWords = response;
      });
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService
      .getAppType()
      .subscribe((response) => {
        this.deviceType = response;
      });
    this.channelName = this.router.url.split("/")[1];
    if (this.channelName.includes("?")) {
      this.channelName = this.channelName.split("?")[0];
    }
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.addStyle();
    this.settingsDataSubscription = this.commanSubscribeService
      .getICWebpageThemeSettings()
      .subscribe((response) => {
        const urlSegments = this.router.url.split('/');
        const groupName = urlSegments.length > 2 ? urlSegments[2] : null;
        const matched = this.groupsData?.find(g => g.group_slug === groupName);
        if (matched && this.groupsData) {
          this.org_info = {
            ...this.org_info,
            channel_logo: matched.group_logo || this.originalChannelLogo
          };
        } else if (!groupName && this.originalChannelLogo) {
          this.org_info = {
            ...this.org_info,
            channel_logo: this.originalChannelLogo
          };
        }
        this.settingsData = response;
        this.addStyle();
        this.scrollNavApply();
      });

    this.appType = this.storageService.getItem("app_type");

    if (this.router.url.includes("/preview")) {
      $(".dropdown-toggle").prop("disabled", true);
    }

    if (Object.keys(this.settingsData).length > 0) this.scrollNavApply();

    this.userIdParam = this.route.snapshot.queryParamMap.get("user_id");

    this.menuNames = ["home", "creators", "fans"];
    this.userInfo = this.commanSubscribeService.userInfo;
    this.commanSubscribeService.getCurrenciesJSON().subscribe((result) => {
        Object.keys(result).forEach((element) => {
          let value = element + " - " + result[element];
          this.currencyJSON.push({ currency: value });
          this.currenciesList.push(value);
        });
      });
    if (
      this.userInfo &&
      this.userInfo.access_token &&
      this.userInfo.id
    ) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
    this.getName();
    if (this.userInfo && this.userInfo.id) {
      this.getAvailBalance();
    }
    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    if (Object.keys(perfomerInfoData).length > 0) {
      this.org_info = perfomerInfoData?.data?.Data[0]?.org_info;
      this.performer_details = perfomerInfoData?.data?.Data[0]?.performer_details;
      this.channelDisplayName = perfomerInfoData?.data?.Data[0]?.channel_display_name;
    }
    this.userInfoSubscription = this.commanSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        console.log("userInfo", this.userInfo);
        this.getName();
        let userInfo = this.storageService.getItem("user_Info");
        if (
          userInfo &&
          userInfo.access_token &&
          this.userInfo &&
          this.userInfo.id
        ) {
          this.loggedIn = true;
          if (this.userInfo && this.userInfo.id) {
            this.getAvailBalance();
          }
        } else {
          this.loggedIn = false;
        }
      });
    this.expoInfoSubscr = this.commanSubscribeService
      .getExpoInfo()
      .subscribe((response) => {
        this.expoInfo = response;
      });
    let userInfo = this.storageService.getItem("user_Info");
    if (
      userInfo &&
      userInfo.access_token &&
      this.userInfo &&
      this.userInfo.id
    ) {
      this.loggedIn = true;
    }

    this.getCurrency = this.storageService.getItem("currency");
    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation =
      locInfo && Object.keys(locInfo).length > 0
        ? locInfo
        : this.storageService.getItem("current_location");
    if (
      !this.currentLocation ||
      Object.keys(this.currentLocation).length == 0
    ) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        if (
          this.currentLocation &&
          this.currentLocation.currency &&
          (Object.keys(this.route.snapshot.queryParams).length == 0 ||
            (Object.keys(this.route.snapshot.queryParams).length > 0 &&
              !this.route.snapshot.queryParams.currency))
        ) {
          setTimeout(() => {
            this.setCurrency();
          }, 1000);
        }
      });
    } else if (
      this.currentLocation &&
      Object.keys(this.currentLocation).length > 0
    ) {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    } else {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    }
    // this.scrollNavApply();

    this.menuList = [
      // {
      //   icon: "fa fa-heart menu-icon mr-10",
      //   name: "Favorites",
      //   link: "user-dashboard/favorites",
      // },
      // {
      //   icon: "fa fa-calendar menu-icon mr-10",
      //   name: "Calendar",
      //   link: "user-dashboard/calendar",
      //   sub_menu: []
      // },

      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Profile",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Basic info",
            type: "basic-info",
            link: '/' + this.channelName + '/user-dashboard/profile-settings/basic-info',
            dualapp: true,
          },
          {
            menu_name: "Change Password",
            type: "change-password",
            link: '/' + this.channelName + '/user-dashboard/profile-settings/change-password',
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-handshake-o menu-icon mr-10",
        name: "My Library",
        link: `${this.channelName}/my-library`,
        sub_menu: [],
      },
      {
        icon: "fa fa-calendar-check-o menu-icon",
        name: "My Events",
        flag: "true",
        sub_menu: [
          {
            menu_name: "Live",
            type: "live_events",
            link: '/' + this.channelName + '/user-dashboard/My-events',
            dualapp: true,
          },
          {
            menu_name: "Upcomming",
            type: "upcomming_events",
            link: '/' + this.channelName + '/user-dashboard/My-UpcomingEvents',
            dualapp: true,
          },
          {
            menu_name: "Past",
            type: "past_events",
            link: '/' + this.channelName + '/user-dashboard/My-PastEvents',
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Payments",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Payment Methods",
            type: "payment-methods",
            link: '/' + this.channelName + '/user-dashboard/payment-methods',
            dualapp: true,
          },
          // {
          //   menu_name: "My Address",
          //   type: "my-address",
          //   link: "user-dashboard/my-address",
          //   dualapp:true
          // },
          {
            menu_name: "Subscribed Channels",
            type: "subscribed-channel",
            link: '/' + this.channelName + '/user-dashboard/subscribed-channel',
            dualapp: this.deviceType == "browser" ? true : false,
          },
          {
            menu_name: "My Purchases",
            type: "my-purchases",
            link: '/' + this.channelName + '/user-dashboard/my-purchases',
            dualapp: true,
          },
          {
            menu_name: "Order History",
            type: "order-history",
            link: '/' + this.channelName + '/user-dashboard/order-history',
            dualapp: true,
          },
          {
            menu_name: "Tips/Donations",
            type: "tips-donations",
            link: '/' + this.channelName + '/user-dashboard/tips-donations',
            dualapp: true,
          },
        ],
      },
      // {
      //   icon: "fa fa-th-large menu-icon",
      //   name: "MY NFTs",
      //   link: "nft/nft-profile",
      //   sub_menu: [],
      //   dualapp: true,
      //   hide: this.isCryptoWallet == 1 ? false : true,
      // },
      // {
      //   icon: "fa fa-heart menu-icon",
      //   name: "My Wishlist",
      //   link: "",
      //   sub_menu: [],
      //   dualapp:true
      // },
    ];
    this.userList = [
      {
        icon: "fa fa-th-large menu-icon mr-10",
        name: "Home",
        link: `/${this.pName}`,
        activeMenuName: "live",
        sub_menu: [],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "Profile",
        link: `/${this.pName}/profile`,
        sub_menu: [],
      },
      {
        icon: "fa fa-calendar menu-icon mr-10",
        name: "Upcoming",
        link: `/${this.pName}/upcoming-events`,
        sub_menu: [],
      },
      {
        icon: "fa fa-video-camera menu-icon mr-10",
        name: "Videos",
        link: `/${this.pName}/videos`,
        sub_menu: [],
      },
      {
        icon: "fa fa-file-audio-o menu-icon mr-10",
        name: "Audios",
        link: `/${this.pName}/audios`,
        sub_menu: [],
      },
      // {
      //   icon: "fa fa-users menu-icon mr-10",
      //   name: "Followers",
      //   link: `/${this.pName}/${this.pId}/followers`,
      //   sub_menu:[]
      // },
    ];
    this.goToUser(this.router.url);
    if (this.menuList) {
      this.menuList.forEach((val) => {
        if (val.menu) {
          val.menu.forEach((submenu) => {
            if (this.router.url.includes(submenu.type.toLowerCase())) {
              submenu.subMenuActive = true;
            } else {
              submenu.subMenuActive = false;
            }
          });
        }
      });
    }
    this.goToMenu(this.router.url);
    // this.getCategory();
    this.subscriptionRightTabMenuActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 2000);
        }
      });
    this.subscriptionRightTabUserActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        setTimeout(() => {
          this.rightTabActive();
        }, 1000);
      });
    if (this.route.snapshot.queryParams.key) {
      this.autoSignin();
      return;
    }
    this.settingsData?.main_bg_color && document.documentElement.style.setProperty('--hover-bg-color', this.settingsData.bg_secondary_color);
    this.getPerformerDetails();

    this.updateMarketplaceText(); 
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.updateMarketplaceText();
      }
    });
    this.getCartProdCountSubscription = this.commanSubscribeService
      .getCartProductCountApi()
      .subscribe((response) => {
        this.getCartProdCount();
    });
  }

  updateMarketplaceText() {
    const urlParts = this.router.url.split('/');
  
    if (urlParts.length === 3 && urlParts[2] === 'event') {
      this.marketplacetext = 'Events';
    } 
    else if (this.router.url.includes('/merchandise/merch-list')) {
      this.marketplacetext = 'Merchandise';
    } 
    else {
      this.marketplacetext = 'Marketplace';
    }
  }
  
  onEnter() {
    //console.log('entered')
  }

  clickAffiliateLink(affiliate_key) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commanSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Become an Affiliate clicked on Album ${albumId ?? ""} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Become an Affiliate clicked on Album ${albumId ?? ""}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    const groupName = this.route.firstChild?.snapshot.params['groupName'] || '';
    const activeGroup = groupName ? this.groupsData?.find((g: any) => g.group_slug === groupName) : null;
    const affiliateData = {
      role_type: 'fan',
      email: this.userInfo?.email || '',
      fan_user_id: this.userInfo?.id || '',
      actual_user_id: this.userInfo?.actual_user_id || '',
      first_name: this.userInfo?.user_first_name || '',
      last_name: this.userInfo?.user_last_name || '',
      phone_number: this.userInfo.user_phone_number || '',
      ...(activeGroup?.group_key && { group_key: activeGroup.group_key }),
      ...(activeGroup?.id && { network_group_id: activeGroup.id }),
      ...(activeGroup?.name && { network_group_name: activeGroup.name }),
      organization_id: this.organizationId || null,
      organization_name : this.org_info?.organization_name || this.org_info?.performer_display_name || '',
      };
    const encodedData = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(affiliateData))));
    let baseUrl = '';
    if (affiliate_key === undefined || affiliate_key === null || affiliate_key === 0) {
      baseUrl = environment.VENDOR_PORTAL + 'affiliate-register/' + this.organizationKey + "/0";
    } else {
      baseUrl = environment.VENDOR_PORTAL + 'affiliate-signin/' + this.organizationKey + "/" + affiliate_key;
    }
    const fullUrl = `${baseUrl}?data=${encodeURIComponent(encodedData)}`;
    // 5. Open in new tab and copy to clipboard
    const el = document.createElement('textarea');
    el.value = fullUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    window.open(fullUrl, '_blank');
  }

  connectToWallet() {
    this.walletID = localStorage.getItem('WalletId');

    this.cryptoAmount = this.commanSubscribeService.getCryptoBalance().subscribe((result) => {
      this.available_balance = result.available_balance;
      this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : 0;
    })

    this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
      if (isweb3 === 'connected') {
        this.web3service.connectAccount().then(() => {
          this.web3service.setContract();
          this.commanSubscribeService.getAccountBalance(this.walletID);
        })
      }
    }).catch((e) => {
      this.dialog.open(WalletConnectDialogComponent, {
        // backdropClass:'blurred',
        // disableClose: true,
        panelClass: "app-consumer-sign-in",
        hasBackdrop: true
      });
    })
  }

  getCryptoBalance() {
    this.commanSubscribeService.getAccountBalance(this.walletID);
  }

  click24_7Channel() {
    const channel = this.channelName || this.router.url.split('/')[1];
    const showferId = this.performerInfoResponse?.data?.Data?.[0]?.showfer_data?.id || '';
    this.router.navigate([`/${channel}/fastChannel`], {
      queryParams: {
        showfer_id: showferId,
        organization_id: this.organizationId
      }
    });
  }
  getAvailBalance() {
    this.walletInfo = this.commanSubscribeService.walletByOrg[this.commanSubscribeService.orgId];
    if (!this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.commanSubscribeService.getAvailBalance((result) => {
        this.walletInfo = result;
      }, this.commanSubscribeService.orgId);
    }
  }

  changeCurrency(event) {
    let getVal = event.split(" -");
    this.currency = event;
    this.storageService.setItem("currency", getVal[0]);
    this.commanSubscribeService.sendCurrencyInfo(getVal[0]);
  }

  setCurrency() {
    let cur =
      Object.keys(this.route.snapshot.queryParams).length > 0 &&
        this.route.snapshot.queryParams.currency
        ? this.route.snapshot.queryParams.currency
        : this.getCurrency;
    this.currenciesList.forEach((element) => {
      let getVal = element.split(" -");
      let code = cur
        ? cur
        : this.currentLocation.currency &&
          this.currentLocation.currency.code.includes('"')
          ? JSON.parse(this.currentLocation.currency.code)
          : this.currentLocation.currency.code;
      if (getVal[0] == code) {
        this.currency = element;
        this.storageService.setItem("currency", getVal[0]);
        this.commanSubscribeService.sendCurrencyInfo(getVal[0]);
      }
    });
  }

  org_info: any = {};
  performer_details: any = {};
  performerInfoResponse: any = {};
  channelDisplayName: string = '';
  async getPerformerInfo(response) {
    // Store the full response for later use
    this.performerInfoResponse = response;
    
    // this.show247Channel = !!response?.data?.Data?.[0]?.showfer_data?.id;
    this.show247Channel = false;
    if (response.data.statusCode === "200") {
      this.subscriptionDetails = response.data.Subscription_details;
      if (response.data.Data && response.data.Data[0]) {
        if (
          response.data.Data &&
          response.data.Data[0] &&
          response.data.Data[0].org_info
        ) {
          this.org_info = response.data.Data[0].org_info;
          this.originalChannelLogo = response.data.Data[0].org_info.channel_logo;
        }
        this.channelDisplayName = response.data.Data[0].channel_display_name;
        this.groupsData = response.data.Data[0].groups;
        const urlSegments = this.router.url.split('/');
        const groupSlugFromUrl = urlSegments.length > 2 ? urlSegments[2]?.split('?')[0] : null;
        const matchedGroupFromUrl = this.groupsData?.find((g: any) => g.group_slug === groupSlugFromUrl);
        if (matchedGroupFromUrl) {
          this.org_info = { ...this.org_info, channel_logo: matchedGroupFromUrl.group_logo || this.originalChannelLogo };
        }
        this.updateIsGroupRoute();
        const orgId = response.data.Data[0].organization_id || null;
        if (orgId) {
          this.featureList = await this.utilityService.loadOrganizationFeatures(orgId);
          this.commanSubscribeService.sendFeatureInfo(this.featureList);
          this.communityAccess = this.utilityService.isActiveFeature(this.featureList, 'community');
        }
        // Always signal org context is ready (even if null) so activity tracking doesn't wait 2s
        this.commanSubscribeService.sendOrgIdInfo(orgId);
        //console.log(this.org_info)
        if (response.data.Data[0].performer_details) {
          this.performer_details = response.data.Data[0].performer_details;
          const pubnub_keyset = response.data.Data?.[0]?.performer_details?.pubnub_keyset;
          // console.log("pubnub_keyset from performerInfo", JSON.parse(pubnub_keyset));
          (pubnub_keyset) ? this.commanSubscribeService.sendPubnubkeysetInfo(JSON.parse(pubnub_keyset) ?? null) : null;
          const data = (this.userInfo && this.userInfo.id && pubnub_keyset) ? this.utilityService.createPubnubUser({
            userId: "fan_" + this.userInfo.id, nickName: this.userInfo.user_display_name, profileUrl: this.userInfo.profile_url, isPartner: 'no'
          }) : null;
        }


      }
    }
  }

  clearSearch() {
    this.searchCurrency = "";
  }

  rightTabActive() {
    this.userList = this.commanSubscribeService.getFilterMenu(
      this.userList,
      this.router.url,
      "allMenu"
    );
  }
  getLiveEvent() {
    this.liveEventSubscr = this.userService
      .getLiveEvents()
      .subscribe((response) => {
        if (response.data.statusCode === "200") {
          let stream_info = response.data.Data.stream_info[0] || {};
          if (
            stream_info.stream_payment_mode == "paid" &&
            response.data.Data.user_subscription_info &&
            response.data.Data.user_subscription_info.length == 0
          ) {
            this.isLiveEvent = false;
          } else {
            this.isLiveEvent = true;
          }
        }
      });
  }

  goBack() {
    const channelName = this.router.url.split('/')[1];
    const segment2 = this.router.url.split('/')[2];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    this.router.navigateByUrl(`${base}/event/schedule/${this.ticket_key}`);
  }

  getOrgInfo() {
    this.orgInfoSubscr = this.userService.getOrgInfo().subscribe((response) => {
      this.orgInfo = response;
    });
  }


  goToUser(link, menu?) {
    // this.storageService.deleteItem('eventInfo');
    this.userList = this.commanSubscribeService.getFilterMenu(
      this.userList,
      link,
      menu
    );
    this.router.navigateByUrl(link);
    if (menu) {
      this.rightsidenav.close();
    }
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  goToMenu(link, menu?) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   link.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }
    let filterSubscriptions = [];
    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      link,
      menu
    );
    if (menu && menu.name == "My Library") {
      if (this.subscriptionDetails.length > 0) {
        this.subscriptionDetails.forEach((element) => {
          if (element.channel_id == 0 || !element.channel_id) {
            filterSubscriptions.push(element);
          }
        });
        let failedSub = filterSubscriptions.filter(
          (e) => e.payment == "failed"
        );
        if (failedSub.length > 0) {
          this.toastr.info("Please subscribe to the channel");
          this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName) + "/subscription-list"]);
          this.rightsidenav.close();
          return;
        }
      } else {
        this.router.navigateByUrl(link);
      }
    }
    if (link) {
      this.router.navigateByUrl(link);
    } else if (menu) {
      let obj = this.menuList.filter((m) => m.name == menu.name)[0];
      this.router.navigateByUrl(obj.sub_menu[0].link);
    }
    if (menu && this.rightsidenav) {
      this.rightsidenav.close();
    }
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  navigateSubmenu(data) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   data.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }

    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      data,
      "subMenu"
    );
    this.rightsidenav.close();
    this.router.navigateByUrl(data);
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }

  rightSideActive() {
    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      this.router.url,
      "allMenu"
    );
    this.rightsidenav.close();
  }

  redirectTo(path) {
    if (!this.router.url.includes("/preview")) {
      if (path != "signin" && path != "signup")
        this.storageService.deleteItem("eventInfo");

      this.storageService.deleteItem("isEvent");
      // this.sidenav.close();
      this.storageService.setItem("skipIcRedirection", this.router.url);
      if (path == "signin") {
        if (!this.router.url.includes("/sign-up")) {
          this.storageService.setItem("skipRedirection", "yes");
        }
        const dialogRef = this.dialog.open(ConsumerSignInComponent, {
          maxWidth: "450px",
          id: "mat-box",
          panelClass:
            Object.keys(this.settingsData).length > 0 &&
              this.settingsData.form_bg_color
              ? "app-consumer-signin"
              : "app-consumer-sign-in",
          disableClose: true,
          data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
          //console.log(result);
          if (result == "success") {
            this.userInfo = this.commanSubscribeService.userInfo;
            this.getPerformerDetails();
            this.ngOnInit();
          }
          if (!this.router.url.includes("/sign-up")) {
            this.storageService.deleteItem("skipIcRedirection");
          }
        });
      } else {
        this.router.navigate([
          "/" + this.snapshot.url.split("/")[1] + "/sign-up",
        ]);
      }
    }
  }

  subscriptionDetails = [];
  getPerformerDetails() {
    this.getCurrency = this.storageService.getItem("currency");
    let code =
      this.currentLocation && this.currentLocation.currency
        ? this.currentLocation.currency.code
        : "";
    let currentCode = code.includes('"') ? JSON.parse(code) : code;
    let localCurrency =
      this.getCurrency && this.getCurrency.includes('"')
        ? JSON.parse(this.getCurrency)
        : this.getCurrency;
    let channel_name = this.router.url.split("/")[1];
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
      },
      response: true,
      body: {
        channel_name: channel_name,
        currency: localCurrency ? localCurrency : currentCode,
        user_id: this.userInfo.id,
      },
    };
    this.ngxLoader.start();
    console.log("Data  : ", data)
    dedupedPost(
      AWS_API.post.bind(AWS_API),
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_PERFORMER_INFO,
      data
    ).then(async (response) => {
      const channelName = response?.data?.Data?.[0]?.channel_display_name;
      if (channelName) {
        this.titleService.setTitle(channelName);
      }
      //this.titleService.setTitle(response.data.Data[0].channel_display_name);

      this.organizationKey = response?.data?.Data?.[0]?.organization_key
      this.organizationId = response?.data?.Data?.[0]?.organization_id
      if (this.topMenuEventsPending) {
        this.loadTopMenuEvents();
      }
      if(this.userInfo?.id && this.organizationId){
        this.getCartProdCount();
      }
      this.ngxLoader.stop();
      if (response.data.statusCode === "200") {
        console.log("performer response", response);
        console.log("organization key :", this.organizationKey)
        this.commanSubscribeService.sendPerfomerInfo(response);
        this.getOrgByAffiliate();
        this.getAffiliatePrograms();
      }
    });
  }

  getAffiliatePrograms() {
    // Shared with the AI agent's identical request when both are in flight (see AffiliateService).
    this.affiliateService.getAffiliatePrograms(this.organizationId).subscribe(res => {
      console.log("affiliate programs result:", res);
      if (res?.status == 0 && Array.isArray(res.result)) {
        this.fanPrograms = res.result
          .map(item => ({
            ...item,
            program_values: item.program_values ? JSON.parse(item.program_values) : {}
          }))
          .filter(item => item.role_type === 'fan'); // 🔥 filter by role_type

        console.log("Filtered affiliate programs:", this.fanPrograms);
      } else {
        console.error('Unexpected response:', res);
      }
    }, error => {
      console.log(error);
    });
  }

  getOrgByAffiliate() {
    console.log("this.userEmail : ", this.userInfo.email);
    // Shared with the AI agent's identical request when both are in flight (see AffiliateService).
    this.affiliateService.getOrganizationsByAffiliate(this.userInfo.email).subscribe(response => {

      if (response.status == 0) {
        console.log("response affiliate organizations : ", response)
        console.log("organization key ", this.organizationKey)
      }
      if (response && response.result) {
        this.affiliateOrgResults = response.result;
        this.evaluateAffiliateFlags();
      }
      const matchedOrgs = response.result.filter(
        org => org.organization_key === this.organizationKey
      );
      if (matchedOrgs) {
        this.affiliateKey = matchedOrgs ? matchedOrgs?.[0]?.affiliate_key : 0;
      }
      console.log("Matching organizations:", matchedOrgs);
      console.log("affiliate key:", this.affiliateKey);
      console.log("Affiliate flag:", this.isAffiliate);
    }, error => {
      console.log(error);
    });
  }

  goToRespectiveScreen(path, type) {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    if (path == "home") this.router.navigateByUrl("");
    else this.router.navigateByUrl(path);
    if (type == "sidenav") this.sidenav.close();
  }

  goToGroup() {
    if (!this.settingsData.is_preview) {
      const channelName = this.performer_details.channel_name;
      const urlSegments = this.router.url.split('/');
      const segment2 = urlSegments[2]?.split('?')[0];
      const reservedSlugs = ['event', 'channel', 'stream', 'watch', 'album', 'subscription-list', 'community', 'merchandise', 'my-library', 'channelSearch', 'sign-up', 'preview', 'user-dashboard'];
      // Only a real group slug keeps the logo on that group's home; any other page (contactus,
      // privacypolicy, ...) goes to the network home - same check as updateIsGroupRoute().
      const isGroup = !!segment2 && !reservedSlugs.includes(segment2) && !!this.groupsData?.find((g: any) => g.group_slug === segment2);
      const groupSlug = isGroup ? segment2 : '';
      const target = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
      this.router.navigateByUrl(target);
      this.commanSubscribeService.getWebPageSettings(0);
    } else if (
      this.route.snapshot.queryParams.token &&
      this.router.url.includes('preview') &&
      !this.router.url.includes('/channel/')
    ) {
      this.router.navigate(
        ['/' + this.performer_details.channel_name + '/preview'],
        { queryParams: { token: this.route.snapshot.queryParams.token } }
      );
    }
  }

  evaluateAffiliateFlags() {
    if (!this.affiliateOrgResults?.length) return;
    const urlSegments = this.router.url.split('/');
    const groupSlug = urlSegments.length > 2 ? urlSegments[2]?.split('?')[0] : null;
    const reservedSlugs = ['event', 'channel', 'stream', 'watch', 'album', 'subscription-list', 'community', 'merchandise', 'my-library', 'channelSearch', 'sign-up', 'preview'];
    const activeGroup = (groupSlug && !reservedSlugs.includes(groupSlug))
      ? this.groupsData?.find((g: any) => g.group_slug === groupSlug)
      : null;

    const isOrgAffiliate = this.affiliateOrgResults.some(
      (org: any) => org.organization_key === this.organizationKey
    );

    if (activeGroup) {
      this.isAffiliate = this.affiliateOrgResults.some(
        (org: any) => org.organization_key === this.organizationKey &&
          org.network_group_name?.toLowerCase() === activeGroup.name?.toLowerCase()
      );
      this.isGroupAffiliate = !this.isAffiliate && isOrgAffiliate;
    } else {
      // On home page: isAffiliate only if affiliated at org level (no specific group)
      this.isAffiliate = this.affiliateOrgResults.some(
        (org: any) => org.organization_key === this.organizationKey && !org.network_group_name
      );
      // Affiliated to a group but not org-level → show "Become an Affiliate" on home page too
      this.isGroupAffiliate = !this.isAffiliate && isOrgAffiliate;
    }

    const matchedOrg = this.affiliateOrgResults.find(
      (org: any) => org.organization_key === this.organizationKey &&
        (!activeGroup || org.network_group_name?.toLowerCase() === activeGroup.name?.toLowerCase())
    );
    this.affiliateKey = matchedOrg ? matchedOrg.affiliate_key : 0;
    console.log("isAffiliate:", this.isAffiliate, "isGroupAffiliate:", this.isGroupAffiliate, "activeGroup:", activeGroup?.name);
  }

  private updateIsGroupRoute() {
    const urlSegments = this.router.url.split('/');
    const segment2 = urlSegments.length > 2 ? urlSegments[2]?.split('?')[0] : null;
    const reservedSlugs = ['event', 'channel', 'stream', 'watch', 'album', 'subscription-list', 'community', 'merchandise', 'my-library', 'channelSearch', 'sign-up', 'preview'];
    this.isGroupRoute = !!(segment2 && !reservedSlugs.includes(segment2) && this.groupsData?.find((g: any) => g.group_slug === segment2));
  }

  goToMainScreen() {
    this.commanSubscribeService.setActiveGroup({ group_slug: '', id: 0 });
    this.getCartProdCount();
    if (!this.settingsData.is_preview) {
      this.router.navigateByUrl("/" + this.performer_details.channel_name);
      this.commanSubscribeService.getWebPageSettings(0);
    } else if (
      this.route.snapshot.queryParams.token &&
      this.router.url.includes("preview") &&
      !this.router.url.includes("/channel/")
    ) {
      this.router.navigate(
        ["/" + this.performer_details.channel_name + "/preview"],
        { queryParams: { token: this.route.snapshot.queryParams.token } }
      );
    }
  }

  getName() {
    if (this.userInfo) {
      if (this.userInfo.user_display_name) {
        let name;
        if (
          this.userInfo.user_display_name &&
          this.userInfo.user_display_name.includes(" ")
        ) {
          name = this.userInfo.user_display_name.split(" ");
          if (name[0] && !name[1] && name[1] != "") {
            this.displayName = name[0][0] + name[0][1];
          } else if (name[1][0] != undefined) {
            this.displayName = name[0][0] + (name[2] ? name[2][0] : name[1][0]);
          } else {
            this.displayName = this.userInfo.user_display_name[0];
          }
        } else if (this.userInfo.user_display_name[1] != undefined) {
          this.displayName =
            this.userInfo.user_display_name[0] +
            this.userInfo.user_display_name[1];
        } else {
          this.displayName = this.userInfo.user_display_name[0];
        }
        // this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_last_name[0];
        this.profileName = this.userInfo.user_display_name;
        // this.profileName = this.userInfo.user_first_name + " " + this.userInfo.user_last_name;
      } else if (this.userInfo.user_first_name) {
        this.displayName =
          this.userInfo.user_first_name[0] + this.userInfo.user_first_name[1];
        this.profileName = this.userInfo.user_first_name;
      } else if (this.userInfo.user_email) {
        this.displayName =
          this.userInfo.user_email[0] + this.userInfo.user_email[1];
      }
    }
  }

  signout() {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    this.storageService.deleteItem("popup");

    let subscribeData = this.commanSubscribeService.subscribePayInfoData;
    if (subscribeData && subscribeData.data) {
      subscribeData.data.Subscription_details = [];
      this.commanSubscribeService.sendSubscribePayInfo(subscribeData);
    }
    this.commanSubscribeService.sendSubscriberPayedInfo([]);
    this.ngxLoader.start();

    // Step 1: Call your backend logout API first
    this.appService.postRequest(API.FAN_LOGOUT, "").subscribe(
      (result) => {
        this.ngxLoader.stop();
        if (result["status"] == 0) {
          // Step 2: Clear all local app state
          this.loggedIn = false;
          localStorage.isFanLoginUser = false;
          this.storageService.deleteItem("user_Info");
          this.storageService.deleteItem("ticket_key");
          this.commanSubscribeService.sendTriggeredEvent({ actionType: 'sign-out', actionName: 'USER_LOGOUT', organizationId: this.commanSubscribeService.orgId || null });
          this.commanSubscribeService.sendUserInfo({});
          this.commanSubscribeService.sendMylistData([]);
          this.commanSubscribeService.sendMediaPlayerData({
            key: "is_show_musicPlayer",
            value: false,
          });
          this.userInfo = {};
          this.rightsidenav.close();
          this.storageService.deleteItem("signInRouteData");
          sessionStorage.removeItem('oidcAttempted');
          sessionStorage.removeItem('groupPreferenceApplied');
          this.commanSubscribeService.activeGroupSlug = '';
          this.storageService.deleteItem("redirectUrlAfterGoogleLogin");
          this.web3service.signout();

          // let url = this.router.url.split("/");
          // this.router.navigate(["/" + url[1]]);

          // Step 3: Trigger OneLogin logout (OIDC)
          const ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;//environment.onelogin_domain;
          // const POST_LOGOUT_REDIRECT_URI = environment.social_auth_redirect_uri;
          const parts = this.router.url.split('/');
          const initial = parts[1]; // nbbl

          const POST_LOGOUT_REDIRECT_URI = initial? `${environment.social_auth_redirect_uri}${initial}`: environment.social_auth_redirect_uri;

          const ID_TOKEN = localStorage.getItem("id_token");

          if (ID_TOKEN) {
            const formattedIdToken = ID_TOKEN.replace(/^"|"$/g, ""); // remove extra quotes
            const logoutUrl =
              `https://${ONELOGIN_DOMAIN}/oidc/2/logout` +
              `?id_token_hint=${encodeURIComponent(formattedIdToken)}` +
              `&post_logout_redirect_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`;

            window.location.href = logoutUrl; // redirect to OneLogin logout page
          } else {
            localStorage.clear();
            window.location.href = POST_LOGOUT_REDIRECT_URI;
          }

        } else {
          this.ngxLoader.stop();
          this.toastr.error(result["message"]);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }


  
  openKoopid() {
    this.openChat = !this.openChat;
  }
  connectPubNubChannels() {
    this.pubnubService.connect(this.user_id.toString(), (success, error) => {
      if (error) {
        console.log("Error while connecting chat user", error);
        this.isPubNubChannelAvailable = false;
        // this.toastr.error("Error while connecting chat user");
        return;
      } else {
        this.pubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              console.log("Error while connecting chat channel", error);
              this.isPubNubChannelAvailable = false;
              // this.toastr.error("Channel not available");
              return;
            }
            this.isPubNubChannelAvailable = true;
            this.openPubNubChannel = openChannel;
          }
        );
      }
    });

    this.pubnubService.receiveMessages(
      this.event_id + "_notifications",
      (response) => {
        let channel = response.channel;
        let message = response.message;
        if (
          channel &&
          this.openPubNubChannel &&
          channel.url == this.openPubNubChannel.url &&
          message.customType == "NETWORKING" &&
          message.data != ""
        ) {
          this.isNetworkNotification = true;
          let data = JSON.parse(message.data);
          this.message = message.message;
          const _channelName = this.router.url.split('/')[1];
          const _segment2 = this.router.url.split('/')[2];
          const _groupSlug = _segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(_segment2) ? _segment2 : '';
          const _base = _groupSlug ? `/${_channelName}/${_groupSlug}` : `/${_channelName}`;
          this.inviteKey =
            environment.CONSUMER_PORTAL +
            `${_base}/event/networking-list/` +
            this.ticket_key +
            "/" +
            data.id;
          setTimeout(() => {
            this.closeBox();
          }, 10000);
        }
      }
    );
  }
  closeBox() {
    this.isNetworkNotification = false;
  }
  copyToClipboard(type) {
    // if (this.eventInfo.publish == 1) {
    const el = document.createElement("textarea");
    el.value = this.inviteKey;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.isNetworkNotification = false;
    this.toastr.success("Copied..!");
    // } else {
    //   this.toastr.info('Please publish the event');
    // }
  }
  joinUrl() {
    this.isNetworkNotification = false;
    window.open(this.inviteKey, "_blank");
  }

  scrollNavApply() {
    $(".navbar").removeClass("affix");
    // let navElement = document.getElementById("navbar");
    // let logoBgElement = document.getElementById("logo-bg");
    $(".navbar").removeClass("ic-affix");
    $(".navbar").removeClass("logo-bg");
    // $('.logo').addClass('logo-bg');
    // if (this.settingsData.bg_primary_color) {
    //   if (navElement) {
    //     navElement.style.backgroundColor = '';
    //   }
    //   if (logoBgElement) {
    //     logoBgElement.style.backgroundColor = this.settingsData.bg_primary_color;
    //   }
    // }

    $(window).scroll(() => {
      $(".navbar").removeClass("affix");
      let navElement = document.getElementById("navbar");
      let logoBgElement = document.getElementById("logo-bg");
      const scrolled = $(document).scrollTop() > 40;
      if (this.newTopMenu && scrolled !== this.menuScrolled) {
        this.menuScrolled = scrolled;
        this.cdRef.detectChanges();
      }
      if (scrolled) {
        $(".navbar").addClass("ic-affix");
        $(".logo").removeClass("logo-bg");
        if (this.settingsData.bg_primary_color) {
          // navElement.style.backgroundColor = this.settingsData.bg_primary_color + " !important";
          if (navElement && !this.newTopMenu) {
            navElement.style.backgroundColor =
              this.settingsData.bg_primary_color + "90";
          }
          if (logoBgElement) {
            logoBgElement.style.backgroundColor = "";
            logoBgElement.style.padding = "5px";
          }
        }
      } else {
        $(".navbar").removeClass("ic-affix");
        // $('.logo').addClass('logo-bg');
        if (this.settingsData.bg_primary_color) {
          if (navElement) {
            navElement.style.backgroundColor = "";
          }
          // if (logoBgElement) {
          //   logoBgElement.style.backgroundColor = this.settingsData.bg_primary_color;
          //   logoBgElement.style.padding = "6px";
          // }
        }
      }
    });
  }

  searchDataOnEnter() {
    this.searchKeyWords = (this.searchKeyWords || '').trim();
    if (!this.searchKeyWords)
      return;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Searching inside album ${albumId} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Searching inside album ${albumId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      clickAction: 'search'
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    let data = {
      searchKeyWords: this.searchKeyWords,
    };
    if (this.newTopMenu) {
      this.recentSearches = addRecentSearch(this.topMenuOrgId, this.searchKeyWords);
    }
    this.landingPageService.sendSearchData(data);
    this.router.navigate(
      [this.commanSubscribeService.getChannelBasePath(this.channelName) + "/channelSearch"],
      { queryParams: { key: this.searchKeyWords } }
    );
  }
  // }

  openpopup() {
    const dialogRef = this.dialog.open(UpdatePaymentDialog, {
      maxWidth: "700px",
      panelClass: "ios-modal",
      disableClose: true,
      data: this.channelName,
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  autoSignin() {
    let data = {
      key: this.route.snapshot.queryParams.key,
    };
    this.appService
      .postRequest(API.PAYMENT_LOGIN, data)
      .subscribe((response) => {
        if (response.status == 0) {
          let userInfo = response.user;
          userInfo.signedIn = true;
          userInfo.access_token = userInfo.session_token;
          userInfo.is_profile_completed = true;
          this.storageService.setItem("user_Info", {
            access_token: userInfo.access_token,
          });
          this.commanSubscribeService.sendUserInfo(userInfo, this.organizationId);
          localStorage.isFanLoginUser = true;
          const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
          if (this.router.url.includes("/channel/")) {
            let subChannel = this.router.url.split("/channel/");
            let name = subChannel[1].includes("?")
              ? subChannel[1].split("?")
              : subChannel[1];
            this.router.navigate([base + "/subscription-list/channel/" + name[0]]);
          } else {
            this.router.navigate([base + "/subscription-list"]);
          }
        }
      });
  }

  navigateToCommunity() {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    this.router.navigate([`${base}/community`]);
  }

  navigateToMerchandise() {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    this.router.navigate([`${base}/merchandise/merch-list`]);
  }

  // Org for the top menu's events: the performer lookup, else the webpage settings or slug info.
  get topMenuOrgId(): number {
    return this.organizationId || this.settingsData?.organization_id || this.commanSubscribeService?.slugInfo?.organization_id || 0;
  }

  // Asked for by the top menu the first time a panel opens (or after idle on wide screens).
  loadTopMenuEvents() {
    const orgId = this.topMenuOrgId;
    this.recentSearches = readRecentSearches(orgId);
    if (!orgId) {
      this.topMenuEventsPending = true;
      return;
    }
    this.topMenuEventsPending = false;
    const groupId = this.commanSubscribeService.activeGroupId || 0;
    const key = `${orgId}:${groupId}`;
    if (key === this.topMenuEventsKey) {
      return;
    }
    this.topMenuEventsKey = key;
    this.topMenuEventsSubscr?.unsubscribe();
    this.topMenuEventsSubscr = this.topMenuEventsService.getEvents(orgId, groupId).subscribe((events) => {
      this.topMenuEvents = events;
      this.cdRef.detectChanges();
    });
  }

  // Type-ahead for the top menu search; subscribed on the first keystroke so page load is untouched.
  suggestTopMenuSearch(term: string) {
    if (!this.suggestionsSubscr) {
      this.suggestionsSubscr = this.searchSuggestionsService.state$.subscribe(state => {
        this.topMenuSuggestionsLoading = state.loading;
        if (state.groups) {
          this.topMenuSuggestions = state.groups;
          this.topMenuSuggestionsFailed = !!state.failed;
        }
      });
    }
    const groupSlug = this.commanSubscribeService.activeGroupSlug;
    this.searchSuggestionsService.suggest(term, {
      basePath: this.commanSubscribeService.getChannelBasePath(this.channelName),
      performerId: this.performer_details?.user_id,
      channelId: this.settingsData?.channelInfo?.channel_id || 0,
      organizationId: this.topMenuOrgId,
      networkGroupId: (groupSlug && this.groupsData?.find((g: any) => g.group_slug === groupSlug)?.id) || 0,
    });
  }

  // Tracked like a search; opens the same page the results page (or Merchandise page) would.
  openTopMenuSuggestion(item: SearchSuggestion) {
    (window as any).umami?.track(`Search suggestion ${item.kind} - ${item.title}`);
    this.commonSubscribeService.sendTriggeredEvent({
      actionType: "network",
      metaData: { title: `Search suggestion ${item.kind}: ${item.title}`, timeStamp: new Date().toISOString() },
      organizationId: this.organizationId || null,
      clickAction: 'search'
    });
    if (item.backHistory) this.commanSubscribeService.albumBackHistory = item.backHistory;
    if (opensSameDetailPage(this.router.url, item.path)) {
      const query = item.queryParams ? '?' + new URLSearchParams(item.queryParams as any).toString() : '';
      window.location.assign(item.path + query);
      return;
    }
    this.router.navigate([item.path], { queryParams: item.queryParams });
  }

  // Same link as the Events page's "View Details": the event's own network and group.
  openTopMenuEvent(event: TopMenuEvent) {
    if (!event?.slug) {
      this.navigateToEvent();
      return;
    }
    this.trackTopMenuEvent(event);
    const path = topMenuEventPath(this.router.url, event, this.groupsData);
    if (isEventDetailUrl(this.router.url)) {
      // Event page to event page: a full load, because the event page would keep showing the old event.
      window.location.assign(path);
      return;
    }
    this.router.navigate([path]);
  }

  // Same tracking as the Events page's "View Details" (umami + triggered event).
  private trackTopMenuEvent(event: TopMenuEvent) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cicked on Event ${event.id} - ${userId}`);
    this.commonSubscribeService.sendTriggeredEvent({
      actionType: "event",
      metaData: {
        title: `Cicked on Event ${event.id}`,
        eventId: event.id,
        eventName: event.title,
        orgId: this.topMenuOrgId || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.topMenuOrgId || null,
      networkGroupId: event.networkGroupId || null,
      clickAction: "event-type",
    });
  }

  private sideMenuVarsFor: any;
  private sideMenuVarsCache: { [name: string]: string } = {};

  /** Theme variables for the new-design right menu; rebuilt only when the settings object changes. */
  get sideMenuVars(): { [name: string]: string } {
    if (this.sideMenuVarsFor !== this.settingsData) {
      this.sideMenuVarsFor = this.settingsData;
      this.sideMenuVarsCache = buildTopMenuVars(this.settingsData);
    }
    return this.sideMenuVarsCache;
  }

  sideMenuIcon(item: any): string {
    return SIDE_MENU_ICONS[item?.type] || SIDE_MENU_ICONS[item?.name] || "fa-angle-right";
  }

  /** New-design right menu: a group header opens its sub-menu (one at a time) instead of navigating. */
  toggleSideGroup(list: any): void {
    const open = !list.activeMenuList;
    (this.menuList || []).forEach((m) => (m.activeMenuList = false));
    list.activeMenuList = open;
  }

  /** Active right-menu item: the network's brand colour, kept readable on the menu panel. */
  get menuActiveColor(): string | null {
    const brand = this.settingsData?.bg_primary_color;
    const panel = this.settingsData?.form_bg_color;
    return brand && panel ? ensureContrast(brand, panel) : brand || null;
  }

  navigateToEvent() {
    this.ngxLoader.start();
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    this.router.navigate([`${base}/event`]);
  }

  addStyle() {
    if (this.settingsData?.font_tertiary_color && this.settingsData?.bg_tertiary_color) {
      const scrollColor = this.settingsData?.font_tertiary_color;
      const scrollBackcolor = this.settingsData?.bg_tertiary_color;
      if (this.scrollElement && (scrollColor || scrollBackcolor)) {
        this.scrollElement.nativeElement.style.setProperty('--scroll-color', scrollColor);
        this.scrollElement.nativeElement.style.setProperty('--scroll-backcolor', scrollBackcolor);
      }
    }
  }

  getlink(type: any) {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (type === 'event') {
      this.router.navigate([`${base}/event`]);
    } else if (type === 'market') {
      this.router.navigate([`${base}/merchandise/merch-list`]);
    }
  }
  getCartProdCount(from?) {
    let url = MERCH_API.CARTPROD_COUNT;

    let networkGroupId = this.commanSubscribeService.activeGroupId ; 
    if(networkGroupId){
      url += `?networkGroupId=${networkGroupId}`;
    }
    if (this.userInfo && this.userInfo.access_token) {
      this.appPaymentService.getRequest(url).subscribe(
        (response) => {
          if (response.status === 0) {
            this.showCartIcon = true;

            response = response.response.result[0];
            this.cartId = response.cart_id;
            // this.cartProdCount = response.cartCount;
            this.goToCart();
            if (this.cartProdCount == 0 && from && from === "cart") {
              let product_info = this.storageService.getItem("product_info");
              if (product_info && product_info.collection_id) {
                this.router.navigateByUrl(
                  "/network-market/product-marketplace/" +
                  product_info.collection_id
                );
              } else {
                this.router.navigateByUrl("/network-market/market");
              }
            }
          } else if (response.status === 1) {
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  goToCart() {
    if (this.userInfo && this.userInfo.id) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Cart Icon Clicked - ${userId}`);
      const data = {
        actionType: "marketplace",
        metaData: {
          title: `Cart Icon Clicked - ${userId}`,
          timeStamp: new Date().toISOString()
        },
         organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
        clickAction: 'marketplace'
      }
      this.commanSubscribeService.sendTriggeredEvent(data);
      let url = MERCH_API.GET_CART_PRODUCTS;
      this.appPaymentService
        .postRequest(url, { cart_id: this.cartId })
        .subscribe(
          (response) => {
            let payload = {
              cart_id: this.cartId,
              cart_products: response.result,
            };
            if (response.status === 0) {
              this.cartProducts = payload.cart_products;
              this.cartProducts = this.cartProducts
                .map(item => ({
                  ...item,
                  product_data: JSON.parse(item.product_data)        
                }))
                .filter(item => item.organization_id === this.organizationId);    
              this.cartProdCount = this.cartProducts?.length

            } else if (response.status === 1) {
            }
          },
          (error) => {
            this.ngxLoader.stop();
          }
        );
    }
  }

  /** Same logo precedence as the classic header's <img> conditions. */
  get headerLogoUrl(): string {
    const channelInfo = this.settingsData?.channelInfo;
    const channelLogo = channelInfo?.channel_logo;
    const orgLogo = this.org_info?.channel_logo;
    if ((orgLogo || channelLogo) && channelInfo?.channel_id == 0) return orgLogo || '';
    if (channelLogo && channelInfo?.channel_id != 0) return channelLogo;
    if (!channelLogo && orgLogo && channelInfo?.channel_id != 0) return orgLogo;
    if (this.org_info?.organization_logo && !orgLogo && !channelLogo) return this.org_info.organization_logo;
    return '';
  }

  get showCurrencySelector(): boolean {
    const url = this.router.url;
    const currencyRoute = url.includes('/subscription-list') || url.includes('/album') ||
      (url.includes('/merchandise') && !url.includes('merchandise/product-shipping')) || this.leftMenu;
    return currencyRoute && !url.includes('/preview');
  }

  get showCartButton(): boolean {
    const url = this.router.url;
    return this.showCartIcon && this.cartProdCount > 0 &&
      !url.includes('merchandise/product-cart') && !url.includes('/merchandise/product-shipping');
  }

  get showAffiliateLink(): boolean {
    return !!this.organizationKey && this.loggedIn &&
      (this.isAffiliate || this.isGroupAffiliate || this.fanPrograms?.length > 0);
  }

  goToCartBox(){
    this.copyLinkPopup = true;
  }

  onCartItemsRemoved(itemIds: number[]) {
    itemIds.forEach(itemId => this.commanSubscribeService.sendTriggeredEvent({
      actionType: "marketplace",
      metaData: {
        title: `Cart item deleted - ${itemId}`,
        itemId: itemId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `delete`
    }));
    this.cartProducts = this.cartProducts.filter(product => !itemIds.includes(product.id));
    // No 'cart' flag: emptying the cart from the dropdown must not redirect to the network marketplace.
    this.getCartProdCount();
  }

  openCartProduct(product) {
    this.copyLinkPopup = false;
    const currentRouteChannel = this.router.url.split('/')[1];
    const base = this.channelName === currentRouteChannel
      ? `${this.commanSubscribeService.getChannelBasePath(this.channelName)}/merchandise`
      : '/network-market';
    const route = this.merchCartService.overviewRoute(base, product);
    this.router.navigate(route.commands, route.extras);
  }

  gotoCheckout() {
    this.copyLinkPopup = false;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cart Icon Clicked - ${userId}`);
    const data = {
      actionType: "marketplace",
      metaData: {
        title: `Cart checkout clicked - ${userId}`,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: 'checkout'
    }
    this.commanSubscribeService.sendTriggeredEvent(data);

    const currentRouteChannel = this.router.url.split('/')[1];

    const isMerchandise = this.channelName === currentRouteChannel;
    const base = isMerchandise
      ? `${this.commanSubscribeService.getChannelBasePath(this.channelName)}/merchandise`
      : '/network-market';

    const extras = this.channelName
      ? { queryParams: { orgId: this.organizationId } }
      : {};
    this.router.navigate([`${base}/product-cart/${this.cartId}`], extras);

  }

  closePopup() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cart icon closed - ${userId}`);
    const u_payload = {
      actionType: "marketplace",
      metaData: {
        title: `Cart icon closed`,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `event-type`
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);
    this.copyLinkPopup = false;
  }

  ngOnDestroy() {
    if (this.suggestionsSubscr) this.suggestionsSubscr.unsubscribe();
    this.pubnubService.disconnect([this.event_id + "_notifications"]);
    if (this.subscriptionRightTabMenuActive)
      this.subscriptionRightTabMenuActive.unsubscribe();
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.publisherStreamSubscription) {
      this.publisherStreamSubscription.unsubscribe();
    }
    if (this.orgInfoSubscr) {
      this.orgInfoSubscr.unsubscribe();
    }
    if (this.liveEventSubscr) {
      this.liveEventSubscr.unsubscribe();
    }
    if (this.subscriptionRightTabUserActive) {
      this.subscriptionRightTabUserActive.unsubscribe();
    }
    if (this.routerevents) {
      this.routerevents.unsubscribe();
    }
    if (this.expoInfoSubscr) this.expoInfoSubscr.unsubscribe();

    if (this.ticketStatus) this.ticketStatus.unsubscribe();
    if (this.performerInfoSubscr) this.performerInfoSubscr.unsubscribe();
    if (this.routeParamsSubscr) this.routeParamsSubscr.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.getCartProdCountSubscription)
      this.getCartProdCountSubscription.unsubscribe();
    if(this.screenStatusSubscription){
      this.screenStatusSubscription.unsubscribe();
    }
    this.topMenuEventsSubscr?.unsubscribe();
  }
}

@Component({
  selector: "app-update-payment",
  templateUrl: "./update-payment.html",
  styleUrls: ["./ic-header.component.scss"],
})
export class UpdatePaymentDialog {
  copyLink: any;
  type: any = "";
  userInfo: any;
  channelName: any;

  constructor(
    public dialogRef: MatDialogRef<UpdatePaymentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private commanSubscribeService: CommanSubscribeService
  ) {
    this.channelName = data;
    // this.copyLink = data.url;
    // this.type = data.type;
    // this.userInfo = data.userInfo;
    // this.settingsData = data.settingsData;
  }

  updatePayment() {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (this.router.url.includes("/channel/")) {
      let subChannel = this.router.url.split("/channel/");
      let name = subChannel[1].includes("?")
        ? subChannel[1].split("?")
        : subChannel[1];
      this.router.navigate([base + "/subscription-list/channel/" + name[0]]);
    } else {
      this.router.navigate([base + "/subscription-list"]);
    }
    this.dialogRef.close();
  }


  closeModal() {
    this.dialogRef.close();
  }
}